import { render, staticRenderFns } from "./DataBody3.vue?vue&type=template&id=eaa3f6a4&"
import script from "./DataBody3.vue?vue&type=script&lang=js&"
export * from "./DataBody3.vue?vue&type=script&lang=js&"
import style0 from "./DataBody3.vue?vue&type=style&index=0&id=eaa3f6a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports